$(document).ready(function(){
  
  // header mega menu tab
  $( ".menu-tab-block" ).hover( function(){
    var tabClass = $(this).attr('data-tab');
    $('.menu-tab-block').removeClass('active-block');
    $('.menu-tab .mega-menu__richtext').removeClass('active-content');
    $(this).addClass('active-block');
    $(this).find('.mega-menu__richtext').addClass('active-content');
    $('.menu-tab-content .mega-menu__image-caption-link').removeClass('show-image');
    $('.menu-tab-content').find(tabClass).addClass('show-image');
  });
  
  // product color swatch -> more button
  $('.product-color-swatch .more-button').on('click', function(){
    $(this).hide();
    $(this).closest('.product-color-swatch').find('.single-variant').removeClass('hide');
  });
  
  // home collection list - slider
  var $carousel_collection_list = $(".js-collection-list").flickity({
    prevNextButtons: false,
    wrapAround: true,
    pageDots: false,
    initialIndex: 1,
    accessibility: true,
    autoPlay: false,
    percentPosition: false,
    cellAlign: "center",
    contain: true,
    draggable: true
  });
  $('.flickity-prev-v1').on( 'click', function() {
    $carousel_collection_list.flickity('previous');
  });
  $('.flickity-next-v1').on( 'click', function() {
    $carousel_collection_list.flickity('next');
  });
  
  // icon click -> video autoplay
  $(".video-play-icon").click(function(){
    $(this).next(".video-container").find("iframe")[0].src += "?autoplay=1&loop=1&autopause=0";
    $(this).next(".video-container").find(".video-poster-img").hide();
    $(this).hide();
  });
  
  // Collection Menu Tab
  var pathname = window.location.pathname;
  $('.collection-menu ul li').each(function(){
    var collection_path = $(this).find('a').attr('href');
    if (pathname.includes(collection_path)){
      $(this).addClass('active');
    }
  });
  
  // Collection mobile filter tab
  $('body').on('click', '.mobile_collection-filter-tab', function(){
    $(this).closest('.sidebar').toggleClass('mobile-sidebar-filter');
  });
  
  // product color swatch less more button
  if($(".product-options-list").length > 0){
    var max_height;
    var min_height = 100;

    max_height = $(".product-options-list .product-variants-list").height();
    product_option_refresh(max_height,min_height);
  }
  
  // product recharge radio
  $('[data-subscription-radio]').on('change', function() {
    let newPrice = $(this).data('subscription-radio');
    $(this).parents('form').find('.add-to-cart-price').html(newPrice);
    if($(this).val() == "otp") {
      $('#sellingPlan').attr('name', '');
    } else {
      $('#sellingPlan').attr('name', 'selling_plan');
    }
  });
  // product add to cart bar change price
  $('#prodBarSellingPlan').on('change', function() {
    let newPrice = $(this.options[this.selectedIndex]).data('price');
    $(this).parents('form').find('.add-to-cart-price').html(newPrice);
  })
  
  // accordion
  $('.accordion-toggle').on('click', function() {
    $('.accordion-content').slideUp();
    $('.accordion-toggle').removeClass('active');
    if($(this).next().is(':hidden')) {
      $(this).next().slideDown();
      $(this).addClass('active');
    } else {
      $(this).next().slideUp();
    }
  });
  
  $(window).bind("load resize", function() {
    var windows_width = $(window).width();
    
    // mobile sliders
    home_featured_collection_slider(windows_width);
    home_logo_slider(windows_width);
    home_logo_slider(windows_width);
    award_slider(windows_width);
    product_recommend_slider(windows_width);
    
    // full width
    js_full_width(windows_width);
    
    // color mask collection - banner tab
    collection_banner_tab(windows_width);
    
  });
  
  // about page -> gallery with text section
  gallerySlider();
  
  
  // collection tag filter modify
  $('.sidebar-block').each(function(){
    $(this).find('.filter-active-tag li').each(function(){
      var $loading_active_tag = $(this).find('[data-active-legacy-filter]').attr('data-tagged');
      var filtertag_html = '<p class="global-button" data-tag="'+$loading_active_tag+'">' + $loading_active_tag + '<span class="icon-cross"></span></p>';
      $('.filter-tag-lists').append(filtertag_html);
      if($loading_active_tag.length>0){
        $('.clear-all-tags').show();
      }
    });
  });
  $('body').on('click', '[data-option-filter]', function(){
    var $active_Tag = $(this).find('input:checked').attr('data-tagged');
    if($active_Tag != undefined){
      var filtertag_html = '<p class="global-button" data-tag="'+$active_Tag+'">' + $active_Tag + '<span class="icon-cross"></span></p>';
    }
    $('.filter-tag-lists').append(filtertag_html);
    $('.clear-all-tags').show();
    
    $(this).closest('.sidebar').removeClass('mobile-sidebar-filter');
    
  });
  $('body').on('click', '.clear-all-tags', function(){
    $(this).hide();    
    $('.sidebar-block').each(function(){
      $(this).find('.filter-active-tag button').each(function(){
        $(this).trigger('click');
      });
    });
    
    $(this).closest('.filter-activate').find('.filter-tag-lists').empty();
  });
  $('body').on('click', '.filter-tag-lists .global-button', function(){
    $(this).remove();
    var $removed_Tag = $(this).attr('data-tag');
    //console.log($removed_Tag);
    $('.sidebar-block').each(function(){
      $(this).find('.filter-active-tag button').each(function(){
        var button_tag_val = $(this).attr('data-tagged');
        if($removed_Tag == button_tag_val){
          $(this).trigger('click');
        }
      });
    });
  });

  // Cart Sidebar ( Ajax Cart ) Recommendation Product Ajax Cart
  $(document).on('click', '.side-cart-recommend .recommend-products .single-rproduct .add-to-cart-btn .product-form__buttons a.button', function(e){
    e.preventDefault();

    customAjaxOnBtnClick(this);
  });

  $(".product-main .product-bundle .product-bundle__link").on('click', function(e){
    e.preventDefault();

    customAjaxOnBtnClick(this);
  });
  
});

function customAjaxOnBtnClick(ele){
  const submitButton = $(ele);
  var pId = submitButton.data('id');

  submitButton.attr('disabled', true).addClass("loading");

  $('.qty-error').remove();
  
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: pId
    },
    dataType: 'json',
    success: function(line_item) {        
      // Update quantity and price
      ShopifyAPI.getCart(ajaxCart.cartUpdateCallback);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof ajaxCart.itemErrorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
}

function home_featured_collection_slider(windows_width){
  if(windows_width<799){
    var $home_featured_collection = $('.shopify-section--featured-collection .product-list').flickity({
      prevNextButtons: false,
      wrapAround: true,
      pageDots: false,
      initialIndex: 1,
      accessibility: true,
      autoPlay: false,
      percentPosition: false,
      cellAlign: "left",
      contain: true,
      draggable: true
    });
    $('.flickity-prev-v2').on( 'click', function() {
      $(this).closest('.shopify-section--featured-collection').find('.product-list').flickity('previous');
    });
    $('.flickity-next-v2').on( 'click', function() {
      $(this).closest('.shopify-section--featured-collection').find('.product-list').flickity('next');
    });
  } else {
    var $home_featured_collection = $('.shopify-section--featured-collection .product-list').flickity();
    $home_featured_collection.flickity('destroy');
  }
}

function home_logo_slider(windows_width){
  if(windows_width<799){
    var $home_logo_slider = $('.shopify-section--logo-list .logo-bar').flickity({
      prevNextButtons: false,
      wrapAround: true,
      pageDots: false,
      initialIndex: 0,
      accessibility: true,
      autoPlay: false,
      percentPosition: false,
      cellAlign: 'center',
      contain: true,
      draggable: true
    });
  } else {
    var $home_logo_slider = $('.shopify-section--logo-list .logo-bar').flickity();
    $home_logo_slider.flickity('destroy');
  }
}

function award_slider(windows_width){
  if(windows_width<799){
    var $award_slider = $('.award-list-slide').flickity({
      prevNextButtons: false,
      wrapAround: true,
      pageDots: false,
      initialIndex: 0,
      accessibility: true,
      autoPlay: false,
      percentPosition: false,
      cellAlign: 'center',
      contain: true,
      draggable: true
    });
  } else {
    var $award_slider = $('.award-list-slide').flickity();
    $award_slider.flickity('destroy');
  }
}

function js_full_width(windows_width){
  var original_width = $('.product-list--collection').width();
  var control_amount = (windows_width - original_width)/2;
  $('.js-full-width').css({"width":windows_width, "margin-left":-control_amount, "margin-right":-control_amount});
}

function product_option_refresh(max_height,min_height){    
  $('.more-less-buttons .icon-type').click(function() {
    if($(this).hasClass("more")){
      $(".product-options-list").animate({height: max_height + 'px'}, 'easing', function(){
        $('.more-less-buttons .icon-type.more').addClass("hide");
        $('.more-less-buttons .icon-type.less').removeClass("hide");
      });
    } else {
      $(".product-options-list").animate({height: min_height + 'px'}, 'easing', function(){
        $('.more-less-buttons .icon-type.more').removeClass("hide");
        $('.more-less-buttons .icon-type.less').addClass("hide");
      });
    }
  });
}

function product_logo_slider(windows_width){
  if(windows_width<799){
    var $product_logo_slider = $('.pdp-form__benefits').flickity({
      prevNextButtons: false,
      wrapAround: true,
      pageDots: true,
      initialIndex: 0,
      accessibility: true,
      autoPlay: false,
      percentPosition: false,
      cellAlign: 'center',
      contain: true,
      draggable: true
    });
  } else {
    var $product_logo_slider = $('.pdp-form__benefits').flickity();
    $product_logo_slider.flickity('destroy');
  }
}

function product_recommend_slider(windows_width){
  if(windows_width<799){
    var $product_recommend_slider = $('.recommended-products--grid .product-list').flickity({
      prevNextButtons: false,
      wrapAround: true,
      pageDots: true,
      initialIndex: 0,
      accessibility: true,
      autoPlay: false,
      percentPosition: false,
      cellAlign: 'left',
      contain: true,
      draggable: true
    });
  } else {
    var $product_recommend_slider = $('.recommended-products--grid .product-list').flickity();
    $product_recommend_slider.flickity('destroy');
  }
}

function gallerySlider(){
  let sliderIndex = 1, maxIndex = 4;
  
  const $contentWidth =$('.content-width');
  const $contentitems = 100 / maxIndex;
  const $btnHomeGalleryArrowLeft = $('.gallery-with-text .gallery__arrow-left');
  const $btnHomeGalleryArrowRight = $('.gallery-with-text .gallery__arrow-right');
  const $GalleryContentWrapper = $('.gallery-with-text .gallery-text');
  const $homeGalleryContent = $('.gallery-with-text .gallery-content');
  const $currentContent= $('.current-content');

  $GalleryContentWrapper.addClass('active-index');
  
  $currentContent.text(`${sliderIndex}`);
  
  $contentWidth.css('width', $contentitems*sliderIndex + '%');

  $btnHomeGalleryArrowRight.on('click', function() {
  $GalleryContentWrapper.removeClass('active-index');
    $GalleryContentWrapper.removeClass('active-last');
  
    sliderIndex++;

    if (sliderIndex > maxIndex) { 
      sliderIndex = 1;
    }
 
    if (sliderIndex == 1) {
      $GalleryContentWrapper.addClass('active-index');
    }
    
    if (sliderIndex == maxIndex) {
      $GalleryContentWrapper.addClass('active-last');
    }
  
    $contentWidth.css('width', $contentitems*sliderIndex + '%');
  
    $homeGalleryContent.hide();

    const $activeGalleryContent = $(`.gallery-content__${sliderIndex}`);
 
    $activeGalleryContent.show();
  
    $currentContent.text(`${sliderIndex}`);
  
    $('img.gallery-img').hide();
    $(`img.gallery-img__${sliderIndex}`).show();
  });
  
  $btnHomeGalleryArrowLeft.on('click', function() {
    $GalleryContentWrapper.removeClass('active-index');
    $GalleryContentWrapper.removeClass('active-last');

    sliderIndex--;

    if (sliderIndex < 1) { 
      sliderIndex = maxIndex;
    }
 
  if (sliderIndex == 1) {
      $GalleryContentWrapper.addClass('active-index');
    }
    
    if (sliderIndex == maxIndex) {
      $GalleryContentWrapper.addClass('active-last');
    }

  $contentWidth.css('width', $contentitems*sliderIndex + '%');

    $homeGalleryContent.hide();

    const $activeGalleryContent = $(`.gallery-content__${sliderIndex}`);
 
    $activeGalleryContent.show();

  $currentContent.text(`${sliderIndex}`);

    $('img.gallery-img').hide();
    $(`img.gallery-img__${sliderIndex}`).show();
  });
}

function collection_banner_tab(windows_width){
  if(windows_width>798){
    $(".js-col-hover li").hover( function(){
      $(".js-col-hover li").removeClass('active');
      $(this).addClass('active');
      var hover_number = $(this).attr('index');
      $('.group-colors').removeClass('active');
      $(`.group-colors-${hover_number}`).addClass('active');
    });
  } else {
    $(".js-col-hover li").click( function(){
      $(".js-col-hover li").removeClass('active');
      $(this).addClass('active');
      $('.collection-color-swatch .group-colors').removeClass('active');
      $(this).closest('.js-col-hover').next().addClass('active');
    });
  }
}

// $(document).ready(function(){
//   $('.js-pdp-trigger').on('click', function(e){
//     e.preventDefault();

//     $('html, body').animate({scrollTop:0},500);
//   })
// })
$(document).ready(function(){
  $('.js-pdp-trigger').on('click', function(e){
    e.preventDefault();

    const target = $('#product_form_7934603329570');

    if(target.length){
      $('html, body').animate({
        scrollTop: target.offset().top - 100
      }, 500);
    }
  });
});